import { createPortal } from 'react-dom'
import {
  InputForm,
  Growth,
  Runway,
  Capital,
  DilutionType,
  GrowthTight,
  InputFormCenter,
  InputFormMail,
  RunwayTyped,
  GrowthProcentage,
  SavedCapital
} from './components'
import { CalcContextProvider } from './context/CalcContext'

export function App() {
  const inputForm = document.getElementById('fejron-calc-input')
  const inputFormCenter = document.getElementById('fejron-calc-input-center')
  const inputFormCenterMobile = document.getElementById(
    'fejron-calc-input-center-mobile'
  )
  const inputFormMail = document.getElementById('fejron-calc-input-mail')
  const growth = document.getElementById('fejron-calc-growth')
  // const growthTight = document.getElementById('fejron-calc-growth-tight')
  const runway = document.getElementById('fejron-calc-runway')
  const capital = document.getElementById('fejron-calc-capital')
  const dilution = document.getElementById('fejron-calc-dilution')
  const dilutionAmount = document.getElementById('fejron-calc-dilution-amount')
  const growthProcentage = document.getElementById('fejron-growth-procent')
  const capitalString = document.getElementById('fejron-capital-string')
  const savedC = document.getElementById('fejron-saved-capital')
  const savedCProcent = document.getElementById('fejron-saved-capital-procent')
  return (
    <>
      <CalcContextProvider>
        {inputForm ? createPortal(<InputForm />, inputForm) : ''}
        {inputFormMail ? createPortal(<InputFormMail />, inputFormMail) : ''}
        {inputFormCenter
          ? createPortal(<InputFormCenter />, inputFormCenter)
          : ''}
        {inputFormCenterMobile
          ? createPortal(<InputFormCenter />, inputFormCenterMobile)
          : ''}
        {growth ? createPortal(<Growth />, growth) : ''}
        {runway ? createPortal(<RunwayTyped />, runway) : ''}
        {capital ? createPortal(<Capital />, capital) : ''}
        {dilution ? createPortal(<DilutionType />, dilution) : ''}
        {savedC ? createPortal(<SavedCapital procent={false} />, savedC) : ''}
        {savedCProcent
          ? createPortal(<SavedCapital procent={true} />, savedCProcent)
          : ''}
        {dilutionAmount
          ? createPortal(<DilutionType procent={false} />, dilutionAmount)
          : ''}
        {growthProcentage
          ? createPortal(<GrowthProcentage type="growth" />, growthProcentage)
          : ''}
        {capitalString
          ? createPortal(<GrowthProcentage type="capital" />, capitalString)
          : ''}
        {/* {growthTight ? createPortal(<GrowthTight />, growthTight) : ''} */}
      </CalcContextProvider>
    </>
  )
}
